import React from 'react';

export default function CardHeader() {
    return (
        <div className="card-header bg-transparent">
            <div className="row align-items-center">
                <div className="col">
                    <h6 className="text-uppercase text-light ls-1 mb-1">Histórico</h6>
                    <h2 className="mb-0">Minhas Operações</h2>
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/CardHeader.js